import { Pencil } from "@/shared/foundation/icons";
import { ButtonLink } from "@/shared/foundation/primitives";
import { type AgentFormSection, Goto } from "@/shared/navigation";

export interface SectionEditLinkProps {
  agentId: string;
  /** The form section the link opens on. */
  section: AgentFormSection;
  /** What is being edited, for the link's accessible name ("Edit goals"). */
  label: string;
}

/**
 * A section card's way in to changing what it shows: the edit form, opened on
 * the matching section.
 */
export function SectionEditLink({
  agentId,
  section,
  label,
}: SectionEditLinkProps) {
  return (
    <ButtonLink
      variant="ghost"
      size="sm"
      icon={<Pencil aria-hidden />}
      href={Goto.createEditAgentRoute(agentId, section)}
      aria-label={`Edit ${label}`}
      data-testid={`agent-detail-${section}-edit`}
    >
      Edit
    </ButtonLink>
  );
}
